import styles from './Footer.module.scss'

const Footer = () => {
  return (
    <footer className={`${styles.footer} ${styles.container}`}>
      <div className={styles.footer__project}>
        <a href='https://rs.school/js/'><img className={styles.footer__project_school} src={require(`../../../assets/icon/logo-rs.png`)} alt="logoRs" /></a>
        <a href='https://github.com/rolling-scopes-school/tasks/blob/master/tasks/stage-2/rs-lang/rslang.md'><img className={styles.footer__project_task} src={require(`../../../assets/icon/logo-git.png`)} alt="logoGit" /></a>
      </div>

      <div className={styles.footer__team}>
        <a className={styles.footer__team_link} href='https://github.com/ZmitserFurmanau' target={'_blank'} rel="noreferrer">Zmitser Furmanau</a>
        <a className={styles.footer__team_link} href='https://github.com/ps0m' target={'_blank'} rel="noreferrer">Sergey Pobudey</a>
        <a className={styles.footer__team_link} href='https://github.com/Glav-Tz' target={'_blank'} rel="noreferrer">Anton Gorshkov</a>
      </div>

      <div className={styles.footer__year}>2022г.</div>

    </footer>
  )
}

export default Footer

